import { render, staticRenderFns } from "./DataInputSelect.vue?vue&type=template&id=b9a7dc50&scoped=true&"
import script from "./DataInputSelect.vue?vue&type=script&lang=js&"
export * from "./DataInputSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataInputSelect.vue?vue&type=style&index=0&id=b9a7dc50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a7dc50",
  null
  
)

export default component.exports